import React, { useEffect, useState } from "react";
import {
  Box,
  TextInput,
  PasswordInput,
  Button,
  Group,
  Stack,
  Image,
  Loader,
  Text,
} from "@mantine/core";
import { Link, useNavigate } from "react-router-dom";
import { auth, functions, logInWithEmailAndPassword } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { httpsCallable } from "firebase/functions";
import { sanitizeDraftId } from "./register";
import "./app.css";

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [installing, setInstalling] = useState(false);
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || installing) {
      // maybe trigger a loading screen
      return;
    }
    if (user && !user.isAnonymous) {
      const rawDraftId = sessionStorage.getItem("captiva_onboarding_draft_id");
      const draftId = sanitizeDraftId(rawDraftId);
      if (rawDraftId && !draftId) {
        sessionStorage.removeItem("captiva_onboarding_draft_id");
      }
      if (draftId) {
        setInstalling(true);
        (async () => {
          try {
            const tokenResult = await user.getIdTokenResult(true);
            const companyId = tokenResult.claims.companyId as string;
            const isOperator =
              tokenResult.claims.role === "operator" || tokenResult.claims.admin === false;
            if (companyId && !isOperator) {
              const installDraftedModule = httpsCallable(functions, "installDraftedModule");
              const installResult = await installDraftedModule({
                claimToken: draftId,
                companyId,
              });
              sessionStorage.removeItem("captiva_onboarding_draft_id");

              const installedConfig = (installResult.data as any)?.moduleConfig;
              const appList: string[] = [];
              if (installedConfig?.forms && installedConfig.forms.length > 0) appList.push("flex");
              if (installedConfig?.entities?.some((e: any) => e.kind === "vehicle" || e.kind === "tank" || e.kind === "fuelType")) appList.push("fuel");
              if (installedConfig?.entities?.some((e: any) => e.kind === "vehicle" || e.kind === "vehicleGroup")) appList.push("trip");
              const appsQuery = appList.length > 0 ? `&apps=${encodeURIComponent(appList.join(","))}` : "";

              window.location.href = `/build/onboard/success?token=${encodeURIComponent(draftId)}${appsQuery}`;
              return;
            } else if (companyId && isOperator) {
              sessionStorage.removeItem("captiva_onboarding_draft_id");
              setInstalling(false);
              navigate("/dashboard/overview");
              return;
            } else {
              setInstalling(false);
              navigate(`/register?draftId=${encodeURIComponent(draftId)}`);
              return;
            }
          } catch (err) {
            console.error("Failed to install drafted module on login:", err);
            sessionStorage.removeItem("captiva_onboarding_draft_id");
            setInstalling(false);
            navigate("/dashboard/overview");
          }
        })();
        return;
      }

      (async () => {
        try {
          const tokenResult = await user.getIdTokenResult(true);
          const companyId = tokenResult.claims.companyId as string;
          if (!companyId) {
            navigate("/register");
            return;
          }
        } catch (e) {
          // ignore token error and proceed
        }
        navigate("/dashboard/overview");
      })();
    }
  }, [user, loading, navigate, installing]);

  if (installing) {
    return (
      <Box className="center" sx={{ maxWidth: 350, textAlign: "center" }} mx="auto">
        <Stack spacing="md" align="center">
          <Image
            radius="md"
            src="/captiva-mark.png"
            style={{ height: "6em", width: "6em", margin: "auto" }}
          />
          <Loader color="cap-navy" size="lg" />
          <Text size="md" weight={500}>
            Installing your drafted module into your company...
          </Text>
        </Stack>
      </Box>
    );
  }

  return (
    <Box className="center" sx={{ maxWidth: 300 }} mx="auto">
      <Stack spacing="xs">
        <Image
          radius="md"
          src="/captiva-mark.png"
          style={{ height: "8em", width: "8em", margin: "auto" }}
        />
        <TextInput
          required
          label="Email"
          placeholder="your@email.com"
          size="md"
          value={email}
          onChange={(e) => setEmail(e.target.value)} 
        ></TextInput>
        <PasswordInput
          required
          label="Password"
          placeholder="password"
          size="md"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Group position="center" mt="md">
          {loginLoading ? (
            <>
              <Loader color="cap-navy" />
            </>
          ) : (
            <>
              <Button
                color="cap-navy"
                size="md"
                style={{ width: "100%" }}
                type="submit"
                onClick={async() =>  {
                  setLoginLoading(true);
                  await logInWithEmailAndPassword(email, password)
                  setLoginLoading(false);
                }
                }
              >
                Submit
              </Button>
              <Link to="/reset">Forgot Password</Link>
            </>
          )}
        </Group>
      </Stack>
    </Box>
  );
}

//     </button>
//     {/* <Button color="cap-navy" className="login__btn login__google" onClick={signInWithGoogle}>
//       Login with Google
//     </button>
//     <div>
//       <Link to="/reset">Forgot Password</Link>
//     </div>
//     <div>
//       Don't have an account? <Link to="/register">Register</Link> now.
//     </div> */}
